interface PaletteColors {
  [key: string]: string;
}

interface Palette {
  grayscale: PaletteColors;
  green: PaletteColors;
  blue: PaletteColors;
  yellowGreen: PaletteColors;
  greenHill: PaletteColors;
  red: PaletteColors;
}

const palette: Palette = {
  grayscale: {
    '50': '#FFFFFF',
    '100': '#EFEFEF',
    '200': '#D8D8D8',
    '300': '#CCCCCC',
    '400': '#C2C2C2',
    '500': '#5C6671',
    '600': '#4D555E',
    '900': '#1C1F22'
  },
  green: {
    '0': '#F6FAF3',
    '50': '#D7EDDC',
    '100': '#ADFD99',
    '200': '#43B05E',
    '300': '#072929',
    '400': '#052D23',
    '900': '#1C1F22'
  },
  greenHill: {
    '50': '#D7EDDC',
    '100': '#96D0A5',
    '400': '#23A844',
    '500': '#1D8D3C',
    '600': '#13622F',
    '700': '#203E3E',
    '950': '#002221'
  },
  blue: {
    '100': '#D1DBE2',
    '200': '#B4C4CF',
    '300': '#97ADBC',
    '500': '#5B7E96',
    '600': '#4C697D',
    '700': '#3C5362',
    '800': '#2B3C48'
  },
  yellowGreen: {
    '200': '#F2FCB7',
    '400': '#F0FC90',
    '600': '#ECF86F',
  },
  red: {
    '50': '#FF7272',
  }
};

export default palette;